import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageModule } from '../language/language.module';
import { ReadOnlyMaterialModules } from './read-only.module.material';
import { ReadOnlyComponent } from './components/read-only/read-only.component';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { DirectiveModule } from '../directive/directive.module';

@NgModule({
  declarations: [ReadOnlyComponent],
  imports: [CommonModule, LanguageModule, ReadOnlyMaterialModules, PipesModule, DirectiveModule],
  exports: [ReadOnlyComponent],
})
export class ReadOnlyModule {}
